import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLangFromPath } from '../i18n';

const SettingsMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = getLangFromPath(location.pathname);
  
  // 修改1: 初始化时直接读取 localStorage，如果是 null 则默认为 'light'
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  // 修改2: 使用 useLayoutEffect 替代 useEffect，防止主题闪烁
  // 它会在浏览器绘制前执行，确保初始渲染时 data-theme 属性已经存在
  useLayoutEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    // 如果没有存储设置，强制使用 'light'
    const currentTheme = savedTheme || 'light';
    
    setTheme(currentTheme);
    document.documentElement.setAttribute('data-theme', currentTheme);
    
    // 如果 localstorage 中没有值，建议写入默认值，避免下次依然判定为空
    if (!savedTheme) {
      localStorage.setItem('theme', 'light');
    }
  }, []);

  const handleLanguageChange = (targetLang) => {
    const path = location.pathname;
    let normalized = path;
    
    // 移除现有的语言前缀
    if (path.startsWith('/en-us')) {
      normalized = path.replace(/^\/en-us/, '') || '/';
    } else if (path.startsWith('/zh-cn')) {
      normalized = path.replace(/^\/zh-cn/, '') || '/';
    }

    if (targetLang === 'zh') {
      // 切换到中文
      const target = normalized === '/' ? '/zh-cn' : `/zh-cn${normalized}`;
      localStorage.setItem('lang', 'zh');
      navigate(`${target}${location.search}`);
    } else {
      // 切换到英文 (默认路径，不加前缀)
      localStorage.setItem('lang', 'en');
      navigate(`${normalized}${location.search}`);
    }
  };

  const toggleTheme = (e) => {
    e?.stopPropagation();
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    window.dispatchEvent(new Event('storage'));
  };

  const handleLangClick = (e) => {
    e?.stopPropagation();
    handleLanguageChange(lang === 'en' ? 'zh' : 'en');
  };

  const isEn = lang === 'en';

  return (
    <div className="settings-buttons" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '10px' }}>
      <button 
        onClick={toggleTheme} 
        className="nav-link settings-btn" 
        style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '1.2rem', padding: '8px 12px' }}
        title={theme === 'light' ? 'Dark Mode' : 'Light Mode'}
      >
        {theme === 'light' ? '🌙':'🔆'}
      </button>
      <button 
        onClick={handleLangClick} 
        className="nav-link settings-btn"
        style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 'bold', padding: '8px 12px', color: 'inherit' }}
      >
        {isEn ? 'CN' : 'EN'}
      </button>
    </div>
  );
};

export default SettingsMenu;
